var React = require('react');

function Resources (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M34 10.6721L6 0L8.8 28.459L15.8 31L34 10.6721Z","fill":"#D6FFCF","key":0}),React.createElement("path",{"d":"M5.5 0L0 27.9508L11 31L5.5 0Z","fill":"#83DE74","key":1}),React.createElement("path",{"d":"M14.4681 37L0 28.16H10.8511L34 11L14.4681 37Z","fill":"#4EB63D","key":2})]);
}

Resources.defaultProps = {"width":"34","height":"37","viewBox":"0 0 34 37","fill":"none"};

module.exports = Resources;

Resources.default = Resources;
